export default {
  yes: 'Yes',
  no: 'No',

  info: 'Info',

  next: 'Next',
  back: 'Back',

  'action.skip': 'Skip',

  'action.login': 'Login',
  'action.show-more': 'Show more',
  'action.show-less': 'Show less',
  'action.accept-terms-and-conditions': 'I have read, understood and accept the {anbs}.',
  'action.send-again': 'Send again',
  'action.login-and-continue': 'Login and continue',
  'action.accept': 'Accept',
  'action.decline': 'Decline',
  'action.switch-back': 'Switch back to own account',
  'action.delete': 'Delete',
  'action.pause': 'Pause',
  'action.forgot-password': 'Password forgotten?',
  'action.reset-password': 'Reset password',
  'action.save': 'Save',
  'action.cancel': 'Cancel',
  'action.confirm': 'Confirm',
  'action.logout': 'Logout',
  'action.search': 'Search',
  'action.open-in-maps': 'Display location',
  'action.book-appointment': 'Book appointment',
  'action.see-more-appointment-proposals': 'Show appointment calendar',

  'action.show-qr-code': 'Please show this code during the admission',
  'action.download': 'download',

  'see-all': 'Show all',
  'register-now': 'Register now',

  'notice.data-privacy':
    'Here you can find the current {dataPrivacyInformation} in accordance with the information obligation pursuant to Art. 13, 14 GDPR.',
  'notice.data-privacy.privacy-information': 'data protection information',

  'action.open': 'Open',
  'action.login-register': 'Login or Register',
};
